import React from "react";
import phone from "../../assets/images/self-recording.jpg";
import Header from "../layout/Header";
import { useNavigate } from "react-router-dom";
import "./Instructions.css";

export default function Instructions({ onRecord }) {
  const navigate = useNavigate();
  const gotoRecording = () => {
    navigate("/recording");
  };
  const breakdown = [
    {
      time: "0:00 – 0:10",
      content: "Introduction: Name, relevant role applied to",
    },
    {
      time: "0:10 – 0:30",
      content:
        "Strengths & Experience: Core competencies, past roles, tools, languages",
    },
    {
      time: "0:30 – 0:50",
      content: "Unique Value Proposition: What sets you apart",
    },
    {
      time: "0:50 – 2:00",
      content: "Enthusiasm & Call to Action: Excitement for the role",
    },
  ];

  function handleRecord() {
    if (typeof onRecord === "function") onRecord();
    gotoRecording();
  }

  return (
    <main className="ft-page" aria-labelledby="ftTitle">
      <Header backDirection={"/intro"} />
      {/* Page Title */}
      <div className="ft-titlebar">
        <h1 id="ftTitle">Flash Training – Your video Presentation</h1>
      </div>

      {/* Goal */}
      <section className="ft-card" aria-labelledby="goalTitle">
        <h2 id="goalTitle" className="ft-h2">
          Goal
        </h2>
        <p className="ft-body">
          Develop an impactful self-pitch that is clear, confident, and aligned
          with company’s expectations. Remember to be in a confident space where
          you can control background noise, light/brightness and camera focus.
        </p>
      </section>

      {/* Content Breakdown */}
      <section className="ft-card" aria-labelledby="cbTitle">
        <h2 id="cbTitle" className="ft-h2">
          Content Breakdown
        </h2>
        <div className="ft-table-wrap">
          <table className="ft-table">
            <thead>
              <tr>
                <th scope="col">Time</th>
                <th scope="col">Content</th>
              </tr>
            </thead>
            <tbody>
              {breakdown.map((row, i) => (
                <tr key={i}>
                  <td>{row.time}</td>
                  <td>{row.content}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Activities */}
      <section className="ft-card" aria-labelledby="actTitle">
        <h2 id="actTitle" className="ft-h2">
          Activities
        </h2>
        <p className="ft-body">
          You will have <strong>Three</strong> attempts to record your video,
          make sure you practice, as you may know, this is how experts are made!
          Below you’ll find three different activities:
        </p>

        <div className="ft-activities">
          <article className="ft-activity">
            <div className="ft-icon">
              {/* Lightbulb */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill-rule="evenodd"
                clip-rule="evenodd"
                image-rendering="optimizeQuality"
                shape-rendering="geometricPrecision"
                text-rendering="geometricPrecision"
                viewBox="0 0 90 90"
              >
                <path
                  fill="#0b8da6"
                  d="M14.5 6.5c4.4.3 5.8 2.4 4 6.5-5.8.5-7.2-1.6-4-6.5Z"
                  opacity=".8"
                />
                <path
                  fill="#0b8ca6"
                  d="M71.5 6.5c5 .5 6 2.7 3 6.5-3 1.2-4.7.2-5-3a7 7 0 0 1 2-3.5Z"
                  opacity=".8"
                />
                <path
                  fill="#0b8aa4"
                  d="M36.5 8.5c25.1-1.7 36.6 10 34.5 35a65.6 65.6 0 0 1-15 23c-2 4.8-3 9.8-3 15a5.8 5.8 0 0 1-5.5 2v3h-6v-3c-2.2.3-4-.3-5.5-2a62 62 0 0 0-2-13c-3.3-5-7-9.6-11-14-11.2-20.4-6.7-35.7 13.5-46Zm2 7c20.3-.6 28.4 9.1 24.5 29a68.5 68.5 0 0 1-13 18c-2 2.7-2.7 5.7-2.5 9h-6c.2-2 0-4-.5-6a116.6 116.6 0 0 1-15-21c-4.4-13.6-.3-23.2 12.5-29Z"
                  opacity=".9"
                />
                <path
                  fill="#0a87a4"
                  d="M2.5 32.5h6v6h-6v-6Zm78 0h6v6h-6v-6Z"
                  opacity=".9"
                />
                <path
                  fill="#0b8fa8"
                  d="M13.5 57.5c5.4-1 7 1 5 6-5.2 1.1-6.8-.9-5-6Z"
                  opacity=".8"
                />
                <path
                  fill="#0b8fa8"
                  d="M70.5 57.5c5.6-.2 7 2 4 6.5-1.4.6-2.7.4-4-.5-1.2-2-1.2-4 0-6Z"
                  opacity=".7"
                />
              </svg>
            </div>
            <h3>Script Writing Workshop</h3>
            <p>
              Write your script using the guidance provided on the table above.
            </p>
          </article>

          <article className="ft-activity">
            <div className="ft-icon">
              {/* Camera */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill-rule="evenodd"
                clip-rule="evenodd"
                image-rendering="optimizeQuality"
                shape-rendering="geometricPrecision"
                text-rendering="geometricPrecision"
                viewBox="0 0 100 100"
              >
                <path
                  fill="#0b88a4"
                  d="M39.5 11.5c6.7-.2 13.3 0 20 .5l2.5 2.5c.5 4 .7 8 .5 12 10.8-1.6 16.8 3 18 14l11-7.5a6 6 0 0 1 5.5.5c.8 15.7.7 31.3-.5 47-1.3 1-2.6 1-4 .5L80 72.5c-.3 5.5-2.4 10-6.5 13.5A294.8 294.8 0 0 1 40 87.5L9.5 87c-3.4-1.1-6-3.3-7.5-6.5-.7-15.7-.7-31.3 0-47 1.5-2.8 3.7-5 6.5-6.5 6.7-.5 13.3-.7 20-.5-.2-2.5.3-4.8 1.5-7 2.8-3.3 6-6 9.5-8Zm2 7h14v8c-6.7.3-13.4 0-20-1l6-7Zm-31 15c19.7-.2 39.3 0 59 .5l1.5 1.5c.7 14.3.7 28.7 0 43-.8.6-1.6 1.1-2.5 1.5-19 .7-38 .7-57 0L9 77.5c-.7-14-.7-28 0-42 .7-.5 1.2-1.2 1.5-2Zm79 10c1.2 8.8 1.3 17.8.5 27a75 75 0 0 0-10-7c-.7-4.3-.7-8.7 0-13 3.1-2.5 6.3-4.8 9.5-7Zm-69 2h12v6h-12v-6Z"
                />
                <path
                  fill="#0a89a3"
                  d="M65.5 15.5c4-.2 8 0 12 .5 1.8 1.7 2.1 3.5 1 5.5-4.3 1-8.6 1.3-13 1v-7Z"
                />
              </svg>
            </div>
            <h3>Recording & Review</h3>
            <p>
              Record yourself, focusing on length, tonality, and expressions.
            </p>
          </article>

          <article className="ft-activity">
            <div className="ft-icon">
              {/* Trophy */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill-rule="evenodd"
                clip-rule="evenodd"
                image-rendering="optimizeQuality"
                shape-rendering="geometricPrecision"
                text-rendering="geometricPrecision"
                viewBox="0 0 100 100"
              >
                <path
                  fill="#0a89a3"
                  d="M44.5 7.5c19-.9 27.5 8.1 25.5 27C65 47.1 55.9 51.9 42.5 49 29 42.2 25.2 31.7 31 17.5c3.4-5 8-8.3 13.5-10Zm2 7c14.6 1 19.5 8.3 14.5 22-5.6 6.4-12 7.6-19.5 3.5-6.5-5.5-7.6-12-3.5-19.5a18 18 0 0 1 8.5-6Z"
                  opacity=".9"
                />
                <path
                  fill="#0b89a4"
                  d="M58.5 51.5c11.6-.7 18.6 4.6 21 16-2.2 10-8.2 13.5-18 10.5-7.9-4.2-11-10.7-9.5-19.5 1.7-2.9 3.9-5.2 6.5-7Z"
                />
                <path
                  fill="#0b89a4"
                  d="M21.5 57.5h27c.2 2-.2 4-1 6-7.6.8-15.3 1.3-23 1.5-2.4 5-1.4 9.3 3 13 6.7 4.3 14 6.4 22 6.5 7.3-1.5 14.6-2 22-1.5l2 2a40.8 40.8 0 0 1-24 6.5 37.1 37.1 0 0 1-31.5-13c-4.2-8.1-3-15.1 3.5-21Z"
                  opacity=".9"
                />
                <path
                  fill="#0a88a2"
                  d="M79.5 74.5c1-.1 2 0 3 .5L95 89.5c1.5 5.2-.3 7-5.5 5.5-5.4-4.4-10.4-9-15-14 2.3-1.8 4-4 5-6.5Z"
                  opacity=".9"
                />
              </svg>
            </div>
            <h3>Top-Performing Examples</h3>
            <p>See great scripts, but remember to be yourself!</p>
          </article>
        </div>
      </section>

      {/* Example */}
      <section className="ft-card" aria-labelledby="exTitle">
        <h2 id="exTitle" className="ft-h2">
          Examples
        </h2>
        <div className="flex quote-cont">
          <div className="blockquote-vline" />
          <blockquote className="ft-quote">
            “Hi, my name is Kevin Morales. I’m applying for the Technical
            Support role. I have 3 years of experience helping customers solve
            hardware and software issues. I’m certified in CompTIA and known for
            resolving 80% of tickets on first contact. I’m excited to join your
            team and bring excellent service to your customers.”
          </blockquote>
        </div>
        <br />
        <div className="flex quote-cont">
          <div className="blockquote-vline" />
          <blockquote className="ft-quote">
            “Hi, I'm Ana Ramirez, a software engineer applying for the Full
            Stack Developer role. I have five years of experience building web
            applications with Python and JavaScript. I'm known for leading
            projects that increased user engagement by 25%. My ability to
            translate technical concepts for business teams sets me apart. I'm
            excited to bring my skills to your innovative team and help build
            your next products.”
          </blockquote>
        </div>
        <br />
        <div className="flex quote-cont">
          <div className="blockquote-vline" />
          <blockquote className="ft-quote">
            “Hello, my name is David Gonzales, and I'm applying for the
            Marketing Manager role. I have seven years of experience executing
            data-driven marketing campaigns, managing budgets up to $500,000. My
            unique value is turning complex data into actionable strategies that
            have boosted lead conversion by 15%. I'm passionate about building
            strong brands and eager to help your company achieve its marketing
            goals.”
          </blockquote>
        </div>
      </section>

      {/* CTA */}
      <div className="ft-cta">
        <button className="ft-btn" onClick={handleRecord}>
          Record Video
        </button>
      </div>
    </main>
  );
}
